const getIcon = (log) => {
    switch (log.module_name) {
        case "WORKFLOW": return "🔄";
        case "COMMENT":  return "💬";
        case "EVIDENCE": return "📎";
        default:         return "✏️";
    }
};

const getTitle = (log) => {
    if (log.module_name === "WORKFLOW") return log.remarks;
    if (log.module_name === "COMMENT") {
    return (
        log.new_value?.type === "issue"
            ? "Issue Raised"
            : "Comment Added"
    );
    }
    if (log.module_name === "EVIDENCE") return log.remarks || "Evidence";
    return log.question_code ? `${log.question_code}` : log.remarks;
};
const formatAuditValue = (value) => {

    if (
        value === 1 ||
        value === "1" ||
        value === true ||
        value === "true"
    ) {
        return "Yes";
    }

    if (
        value === 0 ||
        value === "0" ||
        value === false ||
        value === "false"
    ) {
        return "No";
    }

    return value;
};
const formatStatus = (
    status
) => {

    const map = {

        submitted:
            "Submitted",

        changes_requested:
            "Change Request",

        approved:
            "Approved",

        rework_requested:
            "Rework Requested",

        rejected:
            "Rejected",
                
        draft:
            "Draft"
    };

    return (
        map[status]
        || status
    );
};
const renderBody = (log, onViewDetails) => {
    // Workflow
    if (log.module_name === "WORKFLOW") {

    return (

        <div className="va-audit-body">

            <div className="va-workflow-status text_upparcase">
                <strong>
                    {
                        formatStatus(
                            log.old_value
                                ?.status
                        )
                    }
                </strong>

                {" → "}

                <strong>
                    {
                        formatStatus(
                            log.new_value
                                ?.status
                        )
                    }
                </strong>
            </div>

            {
                log.new_value
                    ?.comment && (

                    <div
                        className="va-workflow-comment"
                    >
                        "
                        {
                            log.new_value
                                .comment
                        }
                        "
                    </div>
                )
            }

        </div>
    );
}


    // Evidence
if (log.module_name === "EVIDENCE") {

    // Reviewer action
    if (
        log.event_type ===
        "EVIDENCE_REVIEW"
    ) {

        return (

            <div className="va-audit-body">

                {log.question_code && (
                    <div>
                        <strong>
                            {
                                log.question_code
                            }
                        </strong>
                    </div>
                )}

                <div className="text_upparcase">
                    📄
                    
<a
    href={log.new_value?.file_url}
    target="_blank"
    rel="noopener noreferrer"
    className="va-evidence-link"
>
    {log.new_value?.file_name}
</a>
                </div>

                <div className="text_upparcase">
                    {
                        
                            log.old_value
                                ?.review_status
                        
                    }

                    {" → "}

                    {
                        
                            log.new_value
                                ?.review_status
                        
                    }
                </div>

            </div>
        );
    }

    // Evidence upload
    const evidence =
        log.new_value ||
        log.old_value;

    return (

        <div className="va-audit-body">

            {log.question_code && (
                <div>
                    <strong>
                        {
                            log.question_code
                        }
                    </strong>
                </div>
            )}

            <div>
                📄
                {" "}

    <a
        href={evidence?.file_url}
        target="_blank"
        rel="noopener noreferrer"
        className="va-evidence-link"
    >
        {evidence?.file_name}
    </a>
            </div>

        </div>
    );
}

    // Comment
    if (log.module_name === "COMMENT") {

    return (

        <div className="va-audit-body">

            {log.new_value?.comment && (

                <div
                    className="va-audit-comment"
                >
                    
                    {
                        log.new_value
                            .comment
                    }
                    
                </div>
            )}

           
        </div>
        );
    }

    // Question — title already shows question_code, so the body only
    // needs the remarks line, not a second copy of the code.
    // Question
    // TABLE ROW AUDIT
if (
    log.module_name === "QUESTION" &&
    log.event_type === "TABLE_ROW"
) {

    const changes =
        log.new_value || [];

    const grouped =
        changes.reduce(
            (acc, change) => {

                const key =
                    change.category ||
                    "Other";

                if (!acc[key]) {
                    acc[key] = [];
                }

                acc[key].push(
                    change
                );

                return acc;

            },
            {}
        );

    return (

        <div className="va-audit-body">

            {
                Object.entries(
                    grouped
                ).map(
                    (
                        [
                            category,
                            rows
                        ]
                    ) => (

                        <div
                            key={
                                category
                            }
                            className="va-audit-table-group"
                        >

                            <div
                                className="va-audit-table-category"
                            >
                                {
                                    category
                                }
                            </div>

                            {
                                rows.map(
                                    (
                                        row,
                                        idx
                                    ) => (

                                        <div
                                            key={
                                                idx
                                            }
                                            className="va-audit-table-row-content"
                                        >

                                            <div
                                                className="va-audit-table-field"
                                            >
                                                {
                                                    row.field
                                                }
                                            </div>

                                            <div
                                                className="va-audit-table-value"
                                            >

                                                <span className="va-audit-old-value">

                                                    {
                                                        row.old ??
                                                        "N/A"
                                                    }

                                                </span>

                                                {" → "}

                                                <span className="va-audit-new-value">

                                                    {
                                                        row.new
                                                    }

                                                </span>

                                            </div>

                                        </div>
                                    )
                                )
                            }

                        </div>
                    )
                )
            }

        </div>
    );
}
const oldValue =
    log.old_value?.value;

const newValue =
    log.new_value?.value;

const hasComplexData =
    Array.isArray(log.old_value) ||
    Array.isArray(log.new_value);

return (
    <div className="va-audit-body">

        {/* Question text */}
        {log.question_text && (
            <div className="va-audit-question">
                {log.question_text}
            </div>
        )}

        {/* Simple value changes */}
        {(oldValue || newValue) && (
            <div className="va-audit-value">

                {oldValue && (
                    <div>
                        <strong>Old:</strong>
                        {" "}
                        {oldValue}
                    </div>
                )}

               <div>
                <strong>
                    {oldValue ? "New:" : "Added:"}
                </strong>
                {" "}
                {formatAuditValue(newValue)}
            </div>

            </div>
        )}

        {/* Fallback when no direct value */}
        {!oldValue &&
         !newValue &&
         !hasComplexData && (
            <div>
                {log.remarks}
            </div>
        )}

        {/* Complex responses */}
        {hasComplexData && (
            <div>
                {log.remarks}

                <button
                    className="va-action-btn"
                    onClick={() =>
                        onViewDetails(log)
                    }
                >
                    View Details
                </button>
            </div>
        )}

    </div>
);
};

const AuditItem = ({ log, onViewDetails }) => {
    return (
        <div className="va-comment-item">
            <div className="va-audit-header">
                <span className="va-audit-module">
                    {getIcon(log)}
                </span>
                <span className="va-audit-title text_upparcase">
                    {getTitle(log)}
                </span>
            </div>
            {renderBody(log, onViewDetails)}
            <div className="va-audit-footer">
                {log.performed_by_name}
                {" • "}
                {log.performed_at}
            </div>
        </div>
    );
};

export default AuditItem;
